import { BlockStack, Text } from '@shopify/polaris'

import { AdaptiveModal } from '../common/AdaptiveModal'
import { WorkflowFilter } from '../common/workflow-models'
import { WorkflowFilters, workflowFilterSections } from '../workflow-page/FiltersCard'

export interface SubscriptionFlowTriggerFiltersModalProps {
  open: boolean
  onClose: () => any
  filters: WorkflowFilter[]
  onChange: (filters: WorkflowFilter[]) => any
}

export const SubscriptionFlowTriggerFiltersModal = (
  props: SubscriptionFlowTriggerFiltersModalProps
) => {
  return (
    <AdaptiveModal
      title="Extra conditions"
      open={props.open}
      onClose={props.onClose}
      primaryAction={{ content: 'Done', onAction: props.onClose }}
      sectioned
    >
      <BlockStack gap="300">
        {props.filters.length === 0 && (
          <Text as="span" tone="subdued">
            No extra conditions specified
          </Text>
        )}
        <WorkflowFilters
          filters={props.filters}
          onChange={props.onChange}
          rootFilterType={'and'}
          onRootFilterTypeChange={() => {}}
          hideRootFilterSelection
          workflowFilterOptions={workflowFilterSections(true)}
        />
      </BlockStack>
    </AdaptiveModal>
  )
}
